import getENV from "../../../../util/getENV";
import useSmartContract from "../../useSmartContract";

export default function useYOLO() {
    //console.log('>>> useYOLO')
    const { modules: { yolo: { contract } } } = getENV();
    const { contract: yolo } = useSmartContract(contract);
    return { yolo }
}